import _ from 'helpers/no_conflict_lodash';

export const CHANGE_SELECTED_PROPERTIES = 'CHANGE_SELECTED_PROPERTIES';
export function changeSelectedProperties(properties) {
  return {
    type: CHANGE_SELECTED_PROPERTIES,
    properties: properties
  };
}

export function resetSelectedProperties() {
  return changeSelectedProperties([]);
}

export function resetSelectedPropertiesOnCurrentPage() {
  return (dispatch, getState) => {
    const properties = getState().search.properties;
    const propertyIds = _.map(properties, property => property.id);
    const selectedPropertyIds = getState().selectList.selectedPropertyIds || [];
    dispatch(changeSelectedProperties(selectedPropertyIds.filter(id => !propertyIds.includes(id))));
  };
}

export function toggleSelectProperty(property) {
  return (dispatch, getState) => {
    const selectedPropertyIds = getState().selectList.selectedPropertyIds || [];
    let newSelected;

    if (selectedPropertyIds.indexOf(property.id) > -1) {
      newSelected = _.filter(selectedPropertyIds, id => id !== property.id);
    } else {
      newSelected = [...selectedPropertyIds, property.id];
    }
    dispatch(changeSelectedProperties(newSelected));
  };
}

export function toggleSelectAllProperties() {
  return (dispatch, getState) => {
    const propertyIds = getState().search.meta.propertyIds;
    dispatch(changeSelectedProperties(propertyIds));
  };
}

export function toggleSelectAllPropertiesOnCurrentPage() {
  return (dispatch, getState) => {
    const properties = getState().search.properties;
    const propertyIds = _.map(properties, property => property.id);
    const selectedPropertyIds = getState().selectList.selectedPropertyIds || [];

    const allSelected = _.every(
      properties, property => selectedPropertyIds.indexOf(property.id) > -1
    );
    if (allSelected) {
      dispatch(changeSelectedProperties(selectedPropertyIds.filter(id => !propertyIds.includes(id))));
    } else {
      dispatch(changeSelectedProperties([...selectedPropertyIds, ...propertyIds]));
    }
  };
}
